import { type ModalProps } from '@mantine/core';
import { closeModal as mantineCloseModal, openContextModal } from '@mantine/modals';

import type { RegisteredModalProps, RegisteredModals } from '../constants/register';

export type ModalSettings = Partial<Omit<ModalProps, 'opened'>> & {
	modalId?: string;
};
export interface OpenContextModal<TCustomProps extends Record<string, any> = {}> extends ModalSettings {
	innerProps: TCustomProps;
}

/**
 * Opens a context-registered modal of `@mantine/modals`
 * @param {TModal} modalName
 * @param {OpenContextModal<RegisteredModalProps<TModal>["innerProps"]>} props
 */
export const openModal = <TModal extends keyof RegisteredModals>(
	modalName: TModal,
	props: OpenContextModal<RegisteredModalProps<TModal>['innerProps']>,
) =>
	openContextModal({
		...props,
		modal: modalName,
	});

/**
 * Closes a context-registered modal of `@mantine/modals`
 * @param {TModal} modalName
 */
export const closeModal = <TModal extends keyof RegisteredModals>(modalName: TModal) => mantineCloseModal(modalName);
